import * as React from "react";
import {useMutation} from "react-apollo";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";
import {ProspectStage} from "./ProspectStage";
import {
    prospectStageMutation,
    isProspectAppliedStage,
    ProspectStageLocation,
    DecisionStageLayout,
} from "./prospectStages";
import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {
    useRecommendations,
    RECOMMENDATION_BANNER_BATCH_SIZE,
} from "../../../Recommendations/RecommendationsProvider/RecommendationsProvider";

export const PopupQuestions = ({onDismiss, isOpen, askHasApplied}) => {
    const [saveUserDecisionStage] = useMutation(prospectStageMutation);
    const {id, name} = useUniversity();
    const {trackEvent} = useAnalytics();
    const {getRecommendationsCallback} = useRecommendations();

    const handleSubmit = React.useCallback(async (prospectStage) => {
        try {
            // THIS FIRES EVENTS/MUTATIONS FOR THE LEGACY FORM WHICH HAS BEEN REMOVED
            await askHasApplied.onClick(isProspectAppliedStage(prospectStage));
            await saveUserDecisionStage({
                variables: {
                    universityId: id,
                    decisionStage: prospectStage,
                    prospectStageLocation: ProspectStageLocation.WIDGET_CHAT,
                },
            });
            await getRecommendationsCallback(RECOMMENDATION_BANNER_BATCH_SIZE);
        } catch (e) {
            console.error("Error submitting university applied question", e);
        }

        trackEvent(sharedEvents.prospectDecisionStageSubmitted.name, {
            universityId: id,
            universityName: name,
            prospectStage,
            where: ProspectStageLocation.WIDGET_CHAT,
            layout: DecisionStageLayout.STACK,
        });
        onDismiss();
    });

    const handleDismiss = React.useCallback(() => {
        trackEvent(sharedEvents.prospectDecisionStageDismissed.name, {
            universityId: id,
            universityName: name,
            where: ProspectStageLocation.WIDGET_CHAT,
            layout: DecisionStageLayout.STACK,
        });
        onDismiss();
    });

    return (
        <ProspectStage
            onDismiss={handleDismiss}
            onSubmit={handleSubmit}
            isOpen={isOpen}
            location={ProspectStageLocation.WIDGET_CHAT}
        />
    );
};
